import API_CONFIG from '../../../config/api';
import { apiFetch, getAuthenticatedUploadUrl } from '../../../api/client';

/**
 * @param {{ prompt: string, modo: 'conectado'|'livre', unidadeCodigo?: string, tomIa?: string }} params
 */
export async function gerarSlideArca({ prompt, modo, unidadeCodigo, tomIa, usarWeb }) {
  const res = await apiFetch('/api/arca/gerar-slide', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt, modo, unidadeCodigo, tomIa, usarWeb: !!usarWeb }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro ao gerar slide.');
  return data;
}

/**
 * Melhora slide com Gemini free (texto).
 * @param {{ slide: object, tomIa?: string, instrucao?: string, modo?: string, unidadeCodigo?: string }} params
 */
export async function melhorarSlideArca({ slide, tomIa, instrucao, modo, unidadeCodigo }) {
  const res = await apiFetch('/api/arca/melhorar-slide', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ slide, tomIa, instrucao, modo, unidadeCodigo }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro ao melhorar slide.');
  return data;
}

/**
 * Gera deck (N slides) com Gemini free.
 * @param {{ prompt: string, modo?: string, unidadeCodigo?: string, tomIa?: string, quantidade?: number }} params
 */
export async function gerarDeckArca({ prompt, modo, unidadeCodigo, tomIa, quantidade, usarWeb }) {
  const res = await apiFetch('/api/arca/gerar-deck', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt, modo, unidadeCodigo, tomIa, quantidade, usarWeb: !!usarWeb }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro ao gerar apresentação.');
  return data;
}

export async function buscarStockArca(query, { page = 1, perPage = 12 } = {}) {
  const qs = new URLSearchParams({
    q: query,
    page: String(page),
    perPage: String(perPage),
  });
  const res = await apiFetch(`/api/arca/stock/search?${qs}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || 'Erro ao buscar imagens.');
    err.code = data.code;
    throw err;
  }
  return data;
}

export async function importarStockArca(foto) {
  const res = await apiFetch('/api/arca/stock/import', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(foto),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || 'Erro ao importar imagem.');
    err.code = data.code;
    throw err;
  }
  return data;
}

/**
 * @param {{ prompt: string }} params
 */
export async function gerarImagemArca({ prompt }) {
  const res = await apiFetch('/api/arca/gerar-imagem', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prompt }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || 'Erro ao gerar ilustração.');
    err.status = res.status;
    err.code = data.code;
    throw err;
  }
  return data;
}

/**
 * @param {File} file
 */
export async function importarArquivoArca(file) {
  const fd = new FormData();
  fd.append('arquivo', file);
  const res = await apiFetch('/api/arca/importar-arquivo', {
    method: 'POST',
    body: fd,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro ao importar arquivo.');
  return data;
}

/** Converte URL relativa do backend em URL absoluta para <img src>.
 * /uploads exige access_token (authMiddleware) — sem isso a imagem não carrega.
 */
export function resolveArcaAssetUrl(url) {
  if (!url) return '';
  if (String(url).startsWith('data:')) return url;
  // CDN externo (thumbs Unsplash na busca) — sem token
  if (/^https?:\/\//i.test(url) && !/\/uploads\//i.test(url)) return url;

  let path = String(url).trim();
  try {
    if (/^https?:\/\//i.test(path)) {
      const u = new URL(path);
      path = u.pathname || '';
    }
  } catch {
    /* mantém */
  }
  path = path.replace(/^\/+/, '');
  if (path.startsWith('uploads/')) path = path.slice('uploads/'.length);
  return getAuthenticatedUploadUrl(path);
}

export async function salvarApresentacaoArca({ id, nome, slides, unidade }) {
  const res = await apiFetch('/api/arca/apresentacoes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, nome, slides, unidade }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro ao salvar apresentação.');
  return data;
}

export async function listarApresentacoesArca(unidade) {
  const qs = unidade ? `?unidade=${encodeURIComponent(unidade)}` : '';
  const res = await apiFetch(`/api/arca/apresentacoes${qs}`);
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(data.error || 'Erro ao listar apresentações.');
  return Array.isArray(data) ? data : [];
}
